import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eInventoryRouteNames } from '../enums/route-names';

export const ASSET_STATE_TYPES_ASSET_STATE_TYPE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inventory/asset-state-types',
        parentName: eInventoryRouteNames.InventoryAdmin,
        name: 'Inventory::Menu:AssetStateTypes',
        layout: eLayoutType.application,
        requiredPolicy: 'Inventory.AssetStateTypes'
      },
    ]);
  };
}
